/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
class WatsonMomentService {
	initialize(glassContext) {
		this._glassContext = glassContext
	}

	shouldShowTooltip() {
		return this._getCurrentTooltipShownCount()
			.then(count=> {
				this._tooltipCount = count
				if (count > 2) {
					return false
				} else {
					this._tooltipCount++
					this._updateWatsonMomentTooltipCount(this._tooltipCount)
					return true
				}
			})
	}

	_getCurrentTooltipShownCount() {
		return this._tooltipCount ?
			Promise.resolve(this._tooltipCount) :
			this._queryWatsonMomentItem().then((wmItem = {}) => wmItem.tooltip_count || 0)
	}

	_queryWatsonMomentItem() {
		return this._glassContext.getCoreSvc('.Ajax').ajax({
			url: `v1/users/~/items/watsonMomentUIHints`,
			type: 'GET',
			headers: {
				'Accept': 'application/json'
			}
		}).then((response = {}) => response.data || {}, () => ({}))
	}

	_updateWatsonMomentTooltipCount(count) {
		return this._glassContext.getCoreSvc('.Ajax').ajax({
			url: `v1/users/~/items/watsonMomentUIHints`,
			type: 'PUT',
			headers: {
				'Content-Type': 'application/json'
			},
			data: JSON.stringify({
				tooltip_count: count
			})
		})	
	}

	/**
	 * For testers to be able to clear the count for a user and test again
	 */
	clearWatsonMomentItem() {
		this._tooltipCount = null
		this._glassContext.getCoreSvc('.Ajax').ajax({
			url: `v1/users/~/items/watsonMomentUIHints`,
			type: 'DELETE',
			headers: {
				'Content-Type': 'application/json'
			}
		})
	}

	/**
	 * Used for test-ui to disable the WM tooltip.  Simply set the count to 3 which will stop the tooltip from showing.
	 */
	disableWMTooltip() {
		this._tooltipCount = 3
	}
}

module.exports = WatsonMomentService